import React, { useState } from 'react';
import { Button, Grid } from '@mui/material';
import TimezoneSelect, { allTimezones } from 'react-timezone-select';
import { useTranslation } from '../../../contexts/translation';
import { ThemeType, useLocalTheme } from '../../../hooks/useLocalTheme';
interface Props {
  defaultTimezone: Timezone;
  onChange: (timezone: Timezone) => void;
}

export interface Timezone {
  value: string;
  label: string;
}

export function DashboardTimezoneModal({ defaultTimezone, onChange }: Props) {
  const { t } = useTranslation();
  const { localTheme } = useLocalTheme();

  const [timezone, setTimezone] = useState<Timezone>(defaultTimezone);
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} style={{ color: localTheme === ThemeType.DARK ? '#000' : undefined }}>
        <TimezoneSelect
          value={timezone.value}
          onChange={(e) => setTimezone({ value: e.value, label: e.label })}
          timezones={{
            ...allTimezones,
            'America/Lima': 'Pittsburgh',
            'Europe/Berlin': 'Frankfurt',
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Button variant="contained" onClick={() => onChange(timezone)}>
          {t('general.action-buttons.apply')}
        </Button>
      </Grid>
    </Grid>
  );
}
